import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
} from 'react'

import * as CheckboxPrimitive from '@radix-ui/react-checkbox'

import CheckIcon from '@/assets/icons/icon-check.svg'
import { classNames } from '@/utils/helpers.ts'

export const Checkbox = forwardRef<
  ElementRef<typeof CheckboxPrimitive.Root>,
  ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> & {
    testId?: string
  }
>(({ className, id, testId, ...props }, ref) => (
  <CheckboxPrimitive.Root
    id={id}
    ref={ref}
    className={classNames(
      'peer h-4 w-4 shrink-0 rounded-sm border-2 border-text-sub ring-offset-background focus-visible:outline-none  data-[state=checked]:border-none data-[state=checked]:bg-primary-500 data-[state=checked]:text-neutral-default',
      props.disabled && 'opacity-50 hover:cursor-not-allowed',
      className,
    )}
    data-testid={testId}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={classNames('flex items-center justify-center text-current')}
    >
      <CheckIcon
        width="10"
        height="10"
      />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName
